import React from 'react'
import DetailContainer from '../MainPage/common/DetailContainer'
import { images } from '../common/images';
import { useLiveConnection } from '../common/useLiveConnection';

// The status is always the device's live connection (/connectionStatus), even
// with a past date picked: the tile answers "is it connected now", not how it
// was on that day. The day data's `connected` is only the fallback when the
// live check fails. It re-checks whenever the day data is re-read (appliance or
// date change, Refresh).
//
// The dashboard passes its day data (an array); the DashBoard cards pass a
// device (the door sensor card a bare object).
function OnlineStatusDetailContainer({ time, selectedDeviceSelectedDayData, showTime = true }) {
  const days = Array.isArray(selectedDeviceSelectedDayData)
    ? selectedDeviceSelectedDayData
    : [selectedDeviceSelectedDayData];
  const lastDay = days[days.length - 1];
  const deviceId = lastDay?.deviceId;

  const liveConnection = useLiveConnection(deviceId, true, selectedDeviceSelectedDayData);
  const checking = liveConnection.checking;
  let connected = liveConnection.connected ?? lastDay?.connected;
  if (deviceId?.startsWith("KP")) {
    connected = true;
  }
  const value = connected ? 'Online' : 'Offline';

  return (
    <DetailContainer
      name={"Device Status"}
      value={checking ? <div className="spinner-border" role="status">
        <span className="sr-only"></span>
      </div> : value}
      // Same red and green as the Appliance Status tile.
      textColor={checking ? undefined : value === 'Offline' ? '#FF0000' : 'rgb(26, 200, 33)'}
      time={time}
      showTime={showTime}
      color={"rgba(118, 190, 194, 0.10)"}
      borderColor={"#76BEC2"}
      image={images.tileDeviceStatus}
    />
  )
}

export default OnlineStatusDetailContainer
